<av-card [backdrop]="true">
  <av-card-header (close)="close()" subtitle="Add one or more tags">
    {{ "Tag this interaction" }}
  </av-card-header>
  <av-card-body size="sm" class="fx-column fx-gap">
    @if (isTagAvailable() || isCustomTagAvailable()) {
    <form #f="ngForm" class="search">
      @if (isTagAvailable()) {
      <av-icon name="magnify" size="md"></av-icon>
      } @if (!isTagAvailable() && isCustomTagAvailable()) {
      <av-icon name="plus" size="xs" class="add"></av-icon>
      }
      <input
        type="search"
        avInput
        name="tag"
        placeholder="{{
          isCustomTagAvailable() && isTagAvailable()
            ? 'Find or create a new tag'
            : isTagAvailable() && !isCustomTagAvailable()
            ? 'Find a tag'
            : 'Type a tag to create'
        }}"
        [ngModel]="tagQuery()"
        (ngModelChange)="tagQuery.set($event)"
      />
      <!-- <div>
        <button avButton ofType="icon" color="accent" size="xs">
          <av-icon name="plus"></av-icon>
        </button>
      </div> -->
    </form>
    } @if (isTagQueryResultsEmpty()) {
    <div
      class="container-pad-md text-center fx-column fx-gap fx-align-center fx-justify-center"
    >
      @if (isTagAvailable()) {
      <span class="text-muted" translate>No tags found</span>
      } @if (isCustomTagAvailable()) {
      <div>
        <button avButton (click)="create(tagQuery())" size="sm" color="accent">
          Add as new Tag
        </button>
      </div>
      }
    </div>
    }
    <div class="search-results">
      <div class="fx-row fx-wrap fx-gap-sm">
        @for (t of tagQueryResults(); track t) {
        <av-tag
          [tag]="t"
          (remove)="remove($event)"
          (add)="add($event)"
          [active]="isTagActive(t)"
          [plus]="true"
        ></av-tag>
        }
      </div>
    </div>
  </av-card-body>
  <!-- <av-card-footer>
  <button avButton size="block" color="accent" (click)="save()" translate>
    Done
  </button>
</av-card-footer> -->
</av-card>
